import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="w-full py-16 md:py-24 px-6" style={{
    backgroundColor: 'var(--cream)'
  }} data-id="element-18">
      <div className="max-w-2xl mx-auto" data-id="element-19">
        {/* Main Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="font-serif text-3xl sm:text-4xl md:text-5xl leading-tight mb-6" style={{
        color: 'var(--navy)'
      }} data-id="element-20">
          No te falta disciplina.{' '}
          <span className="relative inline-block" data-id="element-21">
            Te falta fricción.
            <span className="absolute bottom-0 left-0 w-full h-1 rounded-full" style={{
            backgroundColor: 'var(--gold)'
          }} data-id="element-22" />
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-lg mb-12" style={{
        color: 'var(--navy)',
        opacity: 0.6
      }} data-id="element-23">
          Cobras… y se va. En 14 días se acaba esa niebla.
        </motion.p>

        {/* Divider */}
        <motion.div initial={{
        scaleX: 0
      }} animate={{
        scaleX: 1
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="w-16 h-px mb-16 origin-left" style={{
        backgroundColor: 'var(--gold)'
      }} data-id="element-24" />

        {/* Opening Lead — intimate, poetic */}
        <div className="space-y-6" style={{
        lineHeight: '1.8'
      }} data-id="element-25">
          <motion.p initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.8
        }} className="text-lg md:text-xl" style={{
          color: 'var(--charcoal)'
        }} data-id="element-26">
            Hay un tipo de cansancio que no se arregla durmiendo.
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 1.0
        }} className="text-base md:text-lg" style={{
          color: 'var(--charcoal)'
        }} data-id="element-27">
            Es el cansancio de ser adulta/o, trabajar, cobrar… y aun así sentir
            que el dinero se evapora.
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 1.2
        }} className="text-base md:text-lg" style={{
          color: 'var(--charcoal)'
        }} data-id="element-28">
            De abrir la app del banco con el estómago apretado.
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 1.4
        }} className="text-base md:text-lg" style={{
          color: 'var(--charcoal)'
        }} data-id="element-29">
            De pagar el mínimo "para cumplir"… y ver que la deuda apenas se
            mueve.
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 1.6
        }} className="text-base md:text-lg italic" style={{
          color: 'var(--charcoal)'
        }} data-id="element-30">
            Y entonces te dices lo mismo que te has dicho demasiadas veces:
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 1.8
        }} className="font-serif text-xl md:text-2xl font-medium" style={{
          color: 'var(--navy)'
        }} data-id="element-31">
            "Este mes sí me organizo."
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 2.0
        }} className="text-base md:text-lg" style={{
          color: 'var(--charcoal)'
        }} data-id="element-32">
            Pero la vida llega.
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 2.1
        }} className="text-base md:text-lg" style={{
          color: 'var(--charcoal)'
        }} data-id="element-33">
            Un día pesado. Un antojo. Un "me lo merezco".
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 2.2
        }} className="text-base md:text-lg" style={{
          color: 'var(--charcoal)'
        }} data-id="element-34">
            Y sin darte cuenta vuelves al punto donde todo se siente borroso.
          </motion.p>
        </div>

        {/* Closing statement */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 2.5
      }} className="mt-16 pt-8 border-t" style={{
        borderColor: 'var(--gold)',
        borderTopWidth: '1px'
      }} data-id="element-35">
          <p className="font-serif text-xl md:text-2xl leading-relaxed" style={{
          color: 'var(--navy)',
          lineHeight: '1.6'
        }} data-id="element-36">
            Este Reset de 14 días no está hecho para tu "mejor versión".
          </p>
          <p className="font-serif text-xl md:text-2xl leading-relaxed mt-2 font-semibold" style={{
          color: 'var(--navy)',
          lineHeight: '1.6'
        }} data-id="element-37">
            Está hecho para tu versión cansada.
          </p>
        </motion.div>

        {/* Subtle CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 2.8
      }} className="mt-12 text-center" data-id="element-38">
          <a href="#cta-final" className="inline-block px-8 py-4 rounded-lg text-base font-semibold tracking-wide transition-colors duration-300" style={{
          backgroundColor: 'var(--navy)',
          color: 'var(--gold)',
          border: '1px solid var(--gold)'
        }} aria-label="Quiero mi reset de deudas en 14 días" data-id="element-39">
            QUIERO MI RESET (14 DÍAS)
          </a>
        </motion.div>
      </div>
    </section>;
}